import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import CurrentCity from "./Components/currentCity";

function App() {
  return (
    <div className="App">
      <CurrentCity basename={"upchubi/currentCity"} />
    </div>
  );
}

export default App;
